// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a75f1a58","239":"ad395f7a","453":"ba37560b","667":"db966267"}[chunkId] + ".chunk.js";
};